/**
 * Component to handle the cast market actions
 *
 * @module app/components/CastMarket
 */
import _ from 'lodash';
import BasePage from '../pages/BasePage';
import jQuery from 'jquery';
import OddsFormatProvider from './OddsFormatProvider';
import SelectionViewAdapter from '../views/SelectionViewAdapter';
import SelectionViewTemplate from '../views/templates/SelectionViewTemplate';
import SportsDataRepository from './SportsDataRepository';

var selectionViewTemplate = _.template(SelectionViewTemplate);

var scoreCastElement = null;

var markets = {};

var selectedOption = {};

/**
 * bind cast markets
 *
 * @returns {void}
 *
 * @private
 */
var bind = function () {

    extractValuesFromTemplate();
    getData();
    setupEvents();
};

/**
 * Sets up events
 *
 * @returns {void}
 *
 * @private
 */
var setupEvents = function () {

    jQuery('select', scoreCastElement).off('change.playerSelected')
        .on('change.playerSelected', function () {

            getData();
            jQuery('.show-lines', scoreCastElement).removeClass('displayNone');
        });

    jQuery('.show-more-button', scoreCastElement).off('click.showMore')
        .on('click.showMore', function () {

            var castContainer = jQuery(this).parents('.cpt-score-wincast__team');
            var scores = castContainer.find('.cpt-score-wincast__line-bet.displayNone');

            scores.each(function () {

                var score = jQuery(this);

                if (castContainer.attr('data-fbResult') !== selectedOption.fbResult &&
                    score.attr('data-against') === '0') {

                    score.addClass('displayNone');
                } else {

                    score.removeClass('displayNone');
                }
            });
        });
};

/**
 * Get some values from the template for an easier access
 *
 * @returns {void}
 *
 * @private
 */
var extractValuesFromTemplate = function () {

    markets = {
        'matchCast': scoreCastElement.attr('data-matchCast'),
        'scoreCast': scoreCastElement.attr('data-scoreCast'),
        'firstWincast': scoreCastElement.attr('data-firstWincast'),
        'anyWincast': scoreCastElement.attr('data-anyWincast'),
        'lastWincast': scoreCastElement.attr('data-lastWincast'),
        'firstScorecast': scoreCastElement.attr('data-firstScorecast'),
        'anyScorecast': scoreCastElement.attr('data-anyScorecast'),
        'lastScorecast': scoreCastElement.attr('data-lastScorecast'),
    };
};

/**
 * Actions to fire on the selected option change
 *
 * @returns {void}
 *
 * @private
 */
var handleSelection = function () {

    var selectedOptionNode = jQuery('option:selected', scoreCastElement);

    selectedOption = {
        'name': selectedOptionNode.val(),
        'fs': selectedOptionNode.attr('data-fs'),
        'ag': selectedOptionNode.attr('data-ag'),
        'ls': selectedOptionNode.attr('data-ls'),
        'fbResult': selectedOptionNode.attr('data-fbResult'),
    };

    jQuery('.oddsbutton', scoreCastElement).remove();
    jQuery('.playerName', scoreCastElement).text(selectedOptionNode.val());
    hideScorecasts();
};

/**
 * Compile single selection button
 *
 * @param {Object} selectionModel Selection model
 *
 * @returns {String}
 *
 * @private
 */
var compileSingleSelection = function (selectionModel) {

    return selectionViewTemplate({
        data: selectionModel,
    });
};

/**
 * Hide scorecasts on option change based on option fbResult
 *
 * @returns {void}
 *
 * @private
 */
var hideScorecasts = function () {

    jQuery('.cpt-score-wincast__line-bet[data-role="scorecast"]', scoreCastElement)
        .addClass('displayNone');
    jQuery('.cpt-score-wincast__team[data-fbResult="' + selectedOption.fbResult + '"] ' +
        '.cpt-score-wincast__line-bet[data-role="scorecast"]', scoreCastElement)
        .slice(0, 6).removeClass('displayNone');
};

/**
 * Check data obtained from the AJAX request
 *
 * @param {String} marketId Market ID
 * @param {Object} data AJAX response
 *
 * @returns {void}
 *
 * @private
 */
var checkData = function (marketId, data) {

    if (data && data.error === null && data.status === 'success' && data.data && data.data.prices) {

        updateOddsButtons(marketId, data);

        OddsFormatProvider.updateFragmentOdds(scoreCastElement);
    }
};

/**
 * Get valid slot for the button
 *
 * @param {String} marketId Market ID
 * @param {String} selectionId Selection ID
 *
 * @returns {Object}
 *
 * @private
 */
var getValidSlot = function (marketId, selectionId) {

    var el = jQuery('.cpt-score-wincast__odds-wrapper[data-entityid="' + marketId + '"]' +
        '[data-mainmarketoutcome="OB_OU' + selectionId + '"]', scoreCastElement);

    if (el.length) {

        return el;
    }

    return false;

};

/**
 * Update odds buttons
 *
 * @param {String} marketId Market ID
 * @param {Object} data AJAX data
 *
 * @returns {void}
 *
 * @private
 */
var updateOddsButtons = function (marketId, data) {

    /**
     * Update odds button
     *
     * @param {Object} price Price object from the AJAX request
     *
     * @returns {void}
     *
     * @private
     */
    var updateOddsButton = function (price) {

        var oddsSlot = getValidSlot(marketId, price.sel_2_id); //jshint ignore:line

        if (oddsSlot) {

            oddsSlot.html(compileSingleSelection({
                id: data.data.sel_1_id + '|' + price.sel_2_id, //jshint ignore:line
                status: 'A',
                displayed: 'true',
                name: price.price,
                currentPriceNum: price.price_numerator, //jshint ignore:line
                currentPriceDen: price.price_denominator, //jshint ignore:line
                ancestors: [marketId, jQuery('#eventEntity .col-inner').attr('data-entityid')],
            }));

            SportsDataRepository.addSelectionToModel(
                marketId,
                {
                    id: data.data.sel_1_id + '|' + price.sel_2_id, //jshint ignore:line
                    status: 'A',
                    displayed: 'true',
                    name: price.price,
                    currentPriceNum: price.price_numerator, //jshint ignore:line
                    currentPriceDen: price.price_denominator, //jshint ignore:line
                    ancestors: [marketId, jQuery('#eventEntity .col-inner').attr('data-entityid')],
                }
            );
        }
    };

    _.each(data.data.prices, updateOddsButton);
};

/**
 * AJAX call for the cast market
 *
 * @param {String} marketId Market ID
 * @param {String} selectionId Selection ID
 *
 * @returns {void}
 *
 * @private
 */
var getCastMarket = function (marketId, selectionId) {

    if (marketId) {

        var url = '/castmarketprice/' + marketId.substring(5) + '/' + selectionId.substring(5);

        jQuery.ajax({
            url: window.WH.sportsbook.ctgApi + url, // URL
            dataType: 'json',
        }).done(checkData.bind(this, marketId));
    }
};

/**
 * Does the calls for score cast markets
 *
 * @returns {void}
 *
 * @private
 */
var getScorecasts = function () {

    if (markets.scoreCast === 'true') {

        getCastMarket(markets.firstScorecast, selectedOption.fs);
        getCastMarket(markets.anyScorecast, selectedOption.ag);
        getCastMarket(markets.lastScorecast, selectedOption.ls);
    }
};

/**
 * Does the calls for win cast markets
 *
 * @returns {void}
 *
 * @private
 */
var getWincasts = function () {

    if (markets.matchCast === 'true') {

        getCastMarket(markets.firstWincast, selectedOption.fs);
        getCastMarket(markets.anyWincast, selectedOption.ag);
        getCastMarket(markets.lastWincast, selectedOption.ls);
    }
};

/**
 * Function to obtain the data
 *
 * @returns {void}
 *
 * @private
 */
var getData = function () {

    handleSelection();
    getWincasts();
    getScorecasts();
    BasePage.setOddsFormat();
    SelectionViewAdapter.init();
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    /**
     * Initialize the cast markets
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        scoreCastElement = jQuery('.score-win-cast');

        if (scoreCastElement && scoreCastElement.length &&
            scoreCastElement.attr('data-initialized') === 'false') {

            bind();
            scoreCastElement.attr('data-initialized', 'true');
        }
    },
};

export default api;
    